// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"nameCell__AHJwR","avatar":"avatar__+5WuH"};